/**
 * The one Jarvis app's sign-in (fd-rich-chat PH-06w). The Android app shows this chat in its own view with its own
 * storage, so it starts signed out. Chrome on the same phone is already signed in: the app's sign-in screen opens
 * Chrome at /app-signin, and that page hands the sign-in to the app with one tap through an intent link that names the
 * app's package. The token never leaves the phone and never goes through the server.
 */
export const APP_SIGNIN_PATH = '/app-signin';
export const APP_PACKAGE = 'com.janiczek.jarvis.voice';
/** The app's own link that asks it to open Chrome at APP_SIGNIN_PATH. */
export const FROM_CHROME_LINK = 'jarvisapp://signin-from-chrome';

/** The Jarvis app marks its view's user agent with "JarvisApp/<version>". */
export function isJarvisApp(userAgent: string = typeof navigator === 'undefined' ? '' : navigator.userAgent): boolean {
  return /\bJarvisApp\//.test(userAgent);
}

/** The link Chrome follows to hand the sign-in to the app (explicit package, token as a string extra). */
export function appSigninHref(token: string): string {
  return `intent://signin#Intent;scheme=jarvisapp;package=${APP_PACKAGE};S.jarvis_token=${encodeURIComponent(token)};end`;
}
